import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=aeeb812a&scoped=true"
import script from "./Teaser.vue?vue&type=script&lang=js"
export * from "./Teaser.vue?vue&type=script&lang=js"
import style0 from "./Teaser.vue?vue&type=style&index=0&id=aeeb812a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeeb812a",
  null
  
)

export default component.exports